import styled from 'styled-components';

export const StyledInnerContainer = styled.div`
  padding-left: ${({ theme }) => theme.spacing(4)}px;
  padding-right: ${({ theme }) => theme.spacing(4)}px;
`;
